// extracted by mini-css-extract-plugin
export default {"wrapper":"BingoCardsLayout-module__wrapper"};